import { z } from 'zod'
import { nullSafeOptionalString } from '../shared/schema'

// BL-4216 — default Media ids pre-selected for the Group and Solo variants of
// a Dynamic Intro Video slide. Stored in a single settings doc; either field
// may be empty to mean "no default for this variant".
export const schema = z.object({
  groupMediaId: nullSafeOptionalString(),
  soloMediaId: nullSafeOptionalString(),
})

export type FirestoreSettingsDynamicIntroVideoDefaults = z.infer<typeof schema>

export const empty: FirestoreSettingsDynamicIntroVideoDefaults = Object.freeze(
  schema.parse({
    groupMediaId: '',
    soloMediaId: '',
  })
)
